import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientOfficesGrid: [],
    workClientOfficesAll: [],
    workClientOfficesShow: null,
    pageData: null,
  },
  mutations: {
    setWorkClientOfficesGrid(state, payload) {
      state.workClientOfficesGrid = payload
    },
    setWorkClientOfficesAll(state, payload) {
      state.workClientOfficesAll = payload
    },
    setWorkClientOfficesShow(state, payload) {
      state.workClientOfficesShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workClientOfficesGrid: (state) => {
      return state.workClientOfficesGrid
    },
    workClientOfficesAll: (state) => {
      return state.workClientOfficesAll
    },
    workClientOfficesShow: (state) => {
      return state.workClientOfficesShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkClientOfficesGrid({ commit, rootState }, { limit, page, id, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain +
        '/api/admin/work/client/office/grid?limit=' +
        limit +
        '&page=' +
        page +
        '&filter[]=work_client_id:' +
        id
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientOfficesGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientOfficesAll({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/office/grid?limit=0&filter[]=work_client_id:' +
            id +
            '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientOfficesAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientOfficesShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/office/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientOfficesShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientOfficesCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/office',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {
              message: err.response && err.response.data.name[0]
                ? rootState.translations.notifications['name_is_already_in_use']
                : null,
              IsError: true
            }, {root: true})
          })
      })
    },
    onWorkClientOfficesUpdate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/office',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {
              message: err.response && err.response.data.name[0]
                ? rootState.translations.notifications['name_is_already_in_use']
                : null,
              IsError: true
            }, {root: true})
          })
      })
    },
    onWorkClientOfficesDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/office/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
